// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"AmountInput_inputContainer__1nGBw","input":"AmountInput_input__3wuhb","unit":"AmountInput_unit__37RTK"};